import { render, staticRenderFns } from "./ffcTable.vue?vue&type=template&id=019ef161"
import script from "./ffcTable.vue?vue&type=script&lang=js"
export * from "./ffcTable.vue?vue&type=script&lang=js"
import style0 from "./ffcTable.vue?vue&type=style&index=0&id=019ef161&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports